import type { AiAppCenterModule } from '../types'

export const aiEducationModule: AiAppCenterModule = {
  key: 'aiEducation',
  label: 'AI智慧教育',
  desc: '课程编排 / 智能辅导 / 学习分析',
  path: '/ai-Application-center/ai-education/overview',
  homePath: '/ai-Application-center/ai-education/overview',
  standalonePath: '/ai-Application-center/ai-education/overview',
  icon: 'ep:reading',
  color: '#7c3aed',
  aliases: ['AI 教育', '教育管理']
}
